import { name } from "./block.json";

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block: HTMLElement) {
	const toggleSvgElement = block.querySelector<HTMLButtonElement>('.wp-block-site-specifics__toggle-svg-base');

	toggleSvgElement?.addEventListener('click', function(event) {
		const toggleButtonElement = block.querySelector<HTMLButtonElement>('.wp-block-site-specifics-head__toggle-button');
		toggleButtonElement?.click();
	})
}
